import useAPI from '@/hooks/useAPI';
import StaffEnrollmentRepository from '@/repositories/StaffEnrollmentRepository';

export const useStaffEnrollments = (
  params: {
    jurisdiction?: string;
    insurance_provider?: string;
    insurance_type?: string;
    program_scope?: string;
    only_active?: boolean;
    staff_id?: string;
    person_id?: string;
  },
  enabled: boolean = true
) => {
  const staffEnrollmentRepository = StaffEnrollmentRepository();

  return useAPI({
    queryKey: ['getStaffEnrollments', params],
    queryFn: () => staffEnrollmentRepository.getStaffEnrollments(params),
    enabled
  });
};
